// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ownerList{overflow:initial!important}.actionSelect{max-width:55%!important}.ownerCard{max-height:350px;overflow-y:auto}.emailInput{width:100%}.mainShareCard{min-height:300px;background-color:#fff;overflow:auto}.bold{font-weight:700}", ""]);
// Exports
module.exports = exports;
